import styles from "./index.module.scss";
import { useState } from "react";
import { useAppDispatch } from "../../redux/hooks";
import {
	registration,
	setLoginModal,
	setRegistrationModal,
} from "../../redux/reducers";
import { PatternFormat } from "react-number-format";

const RegistrationModal = () => {
	const dispatch = useAppDispatch();
	const [newuser, setNewUser] = useState<any>({
		firstName: "",
		lastName: "",
		password: "",
		passwordChecker: "",
		phoneNumber: "",
	});

	const submit = () => {
		if (newuser.password === newuser.passwordChecker) {
			dispatch(registration(newuser));
		} else {
			alert("Пароли не совпадают");
		}
	};
	return (
		<div className={styles.root}>
			<div
				className={styles.background}
				onClick={() => dispatch(setRegistrationModal())}
			></div>
			<form action="" className="form">
				<div className="title">Регистрация</div>
				<input
					required
					placeholder="Имя"
					type="text"
					value={newuser.firstName}
					onChange={(e:any) =>
						setNewUser({ ...newuser, firstName: e.target.value })
					}
				/>
				<input
					required
					placeholder="Фамилия"
					type="text"
					value={newuser.lastNname}
					onChange={(e:any) => setNewUser({ ...newuser, lastName: e.target.value })}
				/>
				<PatternFormat
					format="+### ## ### ## ##"
					allowEmptyFormatting
					mask="_"
					value={newuser.phoneNumber}
					onChange={(e:any) =>
						setNewUser({ ...newuser, phoneNumber: e.target.value })
					}
				/>
				<input
					required
					placeholder="Создайте пароль"
					type="password"
					value={newuser.password}
					onChange={(e:any) => setNewUser({ ...newuser, password: e.target.value })}
				/>
				<input
					required
					placeholder="Повторите пароль"
					type="password"
					value={newuser.passwordChecker}
					onChange={(e:any) =>
						setNewUser({ ...newuser, passwordChecker: e.target.value })
					}
				/>
				<h3 className={styles.submit} onClick={submit}>
					Зарегестрироваться
				</h3>
				<p>
					Если вы уже регистрировались, то{" "}
					<span
						onClick={() => {
							dispatch(setRegistrationModal());
							dispatch(setLoginModal());
						}}
					>
						Войти
					</span>
				</p>
				<div
					onClick={() => dispatch(setRegistrationModal())}
					className={styles.close}
				>
					<button type="reset">
						<i className="fa-solid fa-xmark"></i>
					</button>
				</div>
			</form>
		</div>
	);
};

export default RegistrationModal;
